<template>
  <div>
    <Table  ref="selection" :columns="columns" :data="BillingTypeTableList" max-height="600">
        <template slot-scope="{ row, index }" slot="action">
            <a href="#" @click.prevent="EditHandleClick(index)">
            编辑
          </a>
            <Divider type="vertical" />
            <Poptip
            placement="left"
            confirm
            title="你确定要删除这条规则信息吗?"
            @on-ok="remove(index)"
            >
             <Button type="error" ghost size="small">删除</Button>
            </Poptip>
        </template>
    </Table>
  </div>
</template>

<script>
export default {
  name: 'BillingTypeTable',
  props: {
    BillingTypeTableList: Array
  },
  data () {
    return {
      columns: [
        {
          title: '大类名称',
          key: 'Classification'
        },
        {
          title: '开票类型',
          key: 'Name'
        },
        {
          title: '税点',
          key: 'TaxPoint'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    // 点击编辑后回调
    EditHandleClick (index) {
      this.$emit('EditHandleClick', index)
    },
    // 点击删除按钮回调
    remove (index) {
      this.$emit('DeleteHandleClick', index)
    }
  }
}
</script>
